import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faEye } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const Linkedincampaign = () => {

    const navigate = useNavigate();
    const newproductclick = () => {
        navigate('/admin/add-new-facebook-post');
    };
    return (
        <div className="">
            <div className="dashboardbox" style={{ width: "100%" }}>
                {/* <div className="productstogglebar mt-2">
              <div
                className="filterdiv couponfilterdiv"
                onClick={newproductclick}
              >
                <FontAwesomeIcon
                  icon={faPlus}
                  className="iconstyles"
                  style={{ color: "#64748B" }}
                />
                <p>Add Post</p>
              </div>
          </div> */}
                <div className="productstogglebar mt-2">
                    <div className="filterdiv couponfilterdiv questiondiv active"   >
                        <p>Post</p>
                    </div>

                    <div className="filterdiv couponfilterdiv questiondiv active">
                        <p>Campaign</p>
                    </div>

                    <div className="filterdiv couponfilterdiv" onClick={newproductclick}>
                      <FontAwesomeIcon
                     icon={faPlus}
                     className="iconstyles"
                     style={{ color: "#64748B" }}
                />
                <p>Add Post</p>
              </div>
                </div>
                <div
                    className={"ag-theme-quartz mt-4"}
                    style={{ width: "100%", height: 550 }}
                >
                    {/* <AgGridReact
            // modules={AllModules}
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            suppressRowClickSelection={true}
            groupSelectsChildren={true}
            rowSelection={"multiple"}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={paginationPageSizeSelector}
            rowHeight={50}
            // onGridReady={onGridReady}
          /> */}
                </div>
            </div>
        </div>
    )
};
export default Linkedincampaign